module.exports = __webpack_public_path__ + "img/login_bg.d8db8209.png";